module.exports = require("prismjs/components/prism-php.js");